var React = require('react');

function InPersonColor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.9115 2.85562L7.61146 0.546769C6.71198 -0.0834397 5.33125 -0.0490646 4.46615 0.621248L1.59583 2.86135C1.02292 3.30823 0.570312 4.22489 0.570312 4.94677V8.89989C0.570312 10.3608 1.75625 11.5525 3.21719 11.5525H9.39323C10.8542 11.5525 12.0401 10.3666 12.0401 8.90562V5.02125C12.0401 4.24781 11.5417 3.29677 10.9115 2.85562Z","fill":"#A49BA8","key":0}),React.createElement("path",{"d":"M6.30469 9.69043C6.06979 9.69043 5.875 9.49564 5.875 9.26074V7.54199C5.875 7.3071 6.06979 7.1123 6.30469 7.1123C6.53958 7.1123 6.73438 7.3071 6.73438 7.54199V9.26074C6.73438 9.49564 6.53958 9.69043 6.30469 9.69043Z","fill":"#432D4E","key":1})]);
}

InPersonColor.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = InPersonColor;

InPersonColor.default = InPersonColor;
